import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  confirmTitle: ({ spacing }) => css`
    margin: ${spacing.sm} 0 ${spacing.xxs} 0;
  `,
  containerText: ({ spacing }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing.xxs};
    margin-top: ${spacing.sm};
  `,
  reservationCancelledWrapper: ({ spacing }) => css`
    padding: ${spacing.xs};
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      padding-top: ${spacing.xs};
    }
    span {
      margin: ${spacing.xs};
    }
  `,
  reservationCancelledIllustration: ({ spacing }) => css`
    padding: ${spacing.xs};
  `,
})

export default useStyles
